/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const tradingChallengeStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
} as const

export type TradingChallengeStatus =
  (typeof tradingChallengeStatus)[keyof typeof tradingChallengeStatus]
